import fetch from '@/api/fetch'

//  接口参数中添加时间戳
const addTime = param => Object.assign(param, { t: +new Date() })

/**
 * 领取优惠券
 */
export function receiveCoupon(params) {
  return fetch({
    url: '/v1/coupon/direct',
    params: addTime(params)
  })
}

/**
 * 领取直播优惠券
 */
export function receiveLiveCoupon(params) {
  return fetch({
    url: '/v1/coupon/direct',
    params: addTime({ ...params, channel: 'live' })
  })
}
